export default __webpack_public_path__ + "static/media/cheese.6bf4843b.png";